import { Garment } from "./garment.model";
import { LaundryBaseMovement } from "./laundry-base-movement.model";

export class LaundryInputOutput extends LaundryBaseMovement
{
    // id?: number;
    // userId?: number;
    // inputDate: Date;
    // operationDate: Date;
    // direction: string;
    // device: string;
    garment: Garment;
    // status: string;

    constructor()
    {
        super();
        // this.id = 0;
        // this.userId = 0;
        // this.inputDate = new Date();
        // this.operationDate = new Date();
        // this.direction = '';
        // this.device = '';
        this.garment = new Garment();
        // this.status = '';
    }
}


// WEBPACK FOOTER //
// ./src/app/+core/common/model/laundry-input.model.ts